export default __webpack_public_path__ + "static/reach-for-the-stars-fb8fc7e49bbb16ef4b06666e44d675b9.jpg";